$(document).on('submit', '[name=formInteresse], [name=formContato], [formQueroAlugarComprar]', function () {
    var $self = $(this);
    if ($self.data('enviando')) return false;
    var $button = $self.find('[type=submit]');
    if (!$button.data('default-value')) {
        $button.data('default-value', $button.val());
    }


    $self.data('enviando', true);
    //$.fancybox.showLoading();
    $button.val('Enviando...');

    var callback = function (resp) {
        if (resp.redirect_url != undefined) {
            location.href = resp.redirect_url;
            return;
        }
        $self.data('enviando', false);
        //$.fancybox.hideLoading();
        $button.val($button.data('default-value'));

        //if (cb) return cb(resp, $self);

        if (resp.success) {
            window.dataLayer = window.dataLayer || []

            /**
             * @typedef {Object<string,string>} ConversionEvent
             * @property {string} event
             * @property {string} formName
             */

            /**
             * @type ConversionEvent
             */
            let values = {
                event: 'formConversion',
                formName: ''
            }
            $self.find('input').each(function () {
                let $el = $(this)
                let name = $el.attr('name') || ''
                let value = $el.val()

                if ('' !== name && 'recaptcha_token' !== name) {
                    values[name] = value
                }
            })

            let formName = $self.attr('name') || ''
            if ('' !== formName) {
                values.formName = formName
            }

            window.dataLayer.push(values)
            console.table(window.dataLayer)
        }

        alert(resp.msg);
        if (resp.success) {
            $self[0].reset();
            $self.find('[alt=phone]').val('');



            if (resp.redirect_url != undefined) {
                location.href = resp.redirect_url;
            } else {

                location.reload();
            }


        }
    }

    const send = function () {
        $.ajax({
            url: $self.attr('action') + '?t=' + Date.now(),
            type: 'post',
            dataType: 'json',
            data: $self.serializeArray(),
            success: callback,
            error: function () {
                callback({ success: false, msg: "Não foi possível enviar o formulário." });
            }
        });
    }



    if (window.recaptcha_site_key) {
        grecaptcha.ready(function () {
            grecaptcha.execute(window.recaptcha_site_key, { action: 'submit' }).then(function (token) {
                $self.find('[name=recaptcha_token]').remove()
                $self.append('<input type="hidden" name="recaptcha_token" />')
                $self.find('[name=recaptcha_token]').val(token)
    
                send()
            })
        })
    } else {
        send()
    }



    return false;
})